<template lang="pug">
  .notes-and-agreement-section
    .form-col.large-24
      label {{ t('app.registration.transfer_info.notes_and_agreement') }}
      textarea.notes(
        v-model="agreementsInfo.notes_comments"
        placeholder="Enter notes/comments"
        rows="4"
      )
    .form-col.large-24.fileupload
      TranscriptUploadFile(:model_data="agreementsInfo")
    .form-col.large-24.agreement
      .row
        ValidationProvider(
          name="agreement"
          rules="required_true"
          v-slot="{ errors }"
          ref="agreement_checkbox"
        )
          .form-col.large-24
            .field.checkbox-field2
              label(:class="{ error: errors[0] }")
                input.no-custom(
                  type="checkbox"
                  v-model="agreementsInfo.agreements_agreed"
                  id="transfer-agreements-agreed"
                  name="agreement"
                )
                span.label-text
                  | {{ t('app.registration.transfer_info.agreement_text') }}
                  span.required *

    .form-col.large-24
      .row
        validation-provider(rules="required" v-slot="{ errors }" ref="agreements_field_name")
          .form-col.large-12
            span.required *
            label(:class="{error: errors[0]}") {{ t('app.registration.agreements_field_name') }}
            input(
              type="text"
              v-model="agreementsInfo.electronic_signature"
              placeholder="Enter name"
              :class="{error: errors[0]}"
              required
            )
            .small.signatory
              | {{ t('app.registration.transfer_request.agreement_statement') }}
        validation-provider(rules="required" v-slot="{ errors }" ref="agreement_statement")
          .form-col.large-12
            span.required *
            label(:class="{error: errors[0]}") {{ t('app.registration.transfer_info.relationship') }}
            select(v-model="agreementsInfo.relationship")
              option(value="" disabled selected) {{ t('app.registration.transfer_info.select_relationship') }}
              option(v-for="relation in relationships" :key="relation" :value="relation") {{ relation }}
    .form-col.large-24
      .row
        .form-col.large-12
          validation-provider(rules="required|email" v-slot="{ errors }" ref="agreement_email")
            span.required *
            label(:class="{error: errors[0]}") {{ t('app.registration.transfer_info.email') }}
            input(
              type="text"
              v-model="agreementsInfo.email"
              placeholder="Enter email address"
              :class="{error: errors[0]}"
              required
            )
        validation-provider(rules="required" v-slot="{ errors }" ref="agreement_statement")
          .form-col.large-12
            span.required *
            label.required(:class="{error: errors[0]}") {{ t('app.registration.transfer_info.phone_number') }}
            phone(:required="true" :disabled="false" v-model="agreementsInfo.phone_number")
    .form-col.large-24
      p.small.agreements_agreement(v-html="t('app.registration.transfer_info.agreements_agreement')")

</template>

<script>
  import TranscriptUploadFile from '../_upload_file.vue';
  import phone from 'components/phone.vue';
  import { extend } from 'vee-validate';

  extend('required_true', {
    message: 'You must accept the terms.',
    validate: value => value === true
  });

  export default {
    components: { TranscriptUploadFile, phone },
    props: {
      agreementsInfo: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        relationships: [
          'Parent/Legal Guardian',
          'Participant/Self',
          'Sibling',
          'Athletic Director at Receiving School',
          'Assistant Athletic Director at Receiving School',
          'Administration at Receiving School',
          'Office Staff at Receiving School',
          'Other',
        ],
      };
    },
    computed: {
      agreementRules() {
        return this.agreementsInfo.agreements_agreed === true ? '' : 'required';
      },
    },
    methods: {
      handleFileUpload(event) {
        const file = event.target.files[0];
        if (file) {
          this.$emit('update:agreementsInfo', { ...this.agreementsInfo, uploaded_file: file });
        }
      },
      removeFile() {
        this.$emit('update:agreementsInfo', { ...this.agreementsInfo, uploaded_file: null });
      },
    },
  };
</script>
